import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Google Analytics Initialization
const MEASUREMENT_ID = 'G-YL270V89YZ';

// Only the gtag loader is an external <script> (allowlisted in the CSP under
// googletagmanager.com). The dataLayer/config setup runs here as part of the
// bundled app code — served from 'self' — so no inline <script> element is
// created and the CSP never needs 'unsafe-inline'.
const injectGA = () => {
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script1);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  gtag('js', new Date());
  gtag('config', MEASUREMENT_ID);
};

injectGA();

// Crawler-only snapshot baked in at build time (scripts/prerender.js). It is
// hidden and never shown; drop it before the app renders.
document.getElementById('prerender')?.remove();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
